import { Button, Icon, Grid, Segment } from "semantic-ui-react";
import { format } from "date-fns";
import { te } from "date-fns/locale";
import { text } from "../../../../../node_modules/@fortawesome/fontawesome-svg-core/index";

const styles = {
	granteeDescriptionContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	granteeDescriptionTitle: {
		display: "flex",
		justifyContent: "flex-end",
		padding: "0 10px",
		flex: 1,
	},
	granteeDescription: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "start",
		flex: 1,
		textAlign: "left",
	},
};

const GranteeSummary = ({ foundGrantee, onCancel, onUse }) => (
	<Grid.Column
		mobile={16}
		tablet={16}
		computer={16}
		style={{ margin: "10px 40px", textAlign: "center", padding: "10px", borderRadius: "10px", border: "1px solid darkgray" }}
	>
		Une personne a été trouvée dans l'annuaire national des patients.
		<br />
		<b>Voulez-vous remplir le tuteur avec ces données ? </b>
		<Segment>
			{[
				{ label: "Nom de naissance", value: foundGrantee.birth_name },
				{ label: "Prénom(s)", value: foundGrantee.first_name },
				{ label: "Genre", value: foundGrantee.gender?.toLowerCase() === "m" ? "Homme" : "Femme" },
				{ label: "Nom marital", value: foundGrantee.marital_name },
				{
					label: "Date de naissance",
					value: foundGrantee.birth_date ? format(new Date(foundGrantee.birth_date), "yyyy-MM-dd") : "/",
				},
				{ label: "GSM", value: foundGrantee.phone },
				{ label: "Adresse email", value: foundGrantee.email },
				{
					label: "Adresse",
					value: `${foundGrantee.address?.street}, ${foundGrantee.address?.complement ? foundGrantee.address?.complement + ", " : ""} ${
						foundGrantee.address?.postal_code
					} ${foundGrantee.address?.city} ${foundGrantee.address?.country}`,
				},
			]
				.filter((item) => !!item.value)
				.map((item, idx) => (
					<div key={idx} style={styles.granteeDescriptionContainer}>
						<span style={styles.granteeDescriptionTitle}>{item.label} :</span>
						<span style={styles.granteeDescription}>{item.value}</span>
					</div>
				))}
		</Segment>
		<Button color="red" onClick={onCancel}>
			<Icon name="close" /> Annuler
		</Button>
		<Button color="green" onClick={onUse}>
			<Icon name="long arrow alternate down" /> Utiliser ces données
		</Button>
	</Grid.Column>
);
export default GranteeSummary;
